<template>
  <v-container>
    <v-row dense>
      <v-col>
        <v-card>
              <v-card-title
                class="text-h5 d-flex justify-center my-3" style="color:#1f245b"
              >
              <v-icon
                color="#1f245b"
                class="ma-2"
                large
              >
                mdi-waves
              </v-icon>
              SIPENJAJA BUKU PINTAR
              </v-card-title>
              <v-card-subtitle class="text-subtitle-1 d-flex justify-center mt-n6" style="color:#1f245b">Sistem Pengendali Jarak Jauh Buka Tutup Pintu Air</v-card-subtitle>

              <v-divider class="mx-2"></v-divider>

              <v-card-text class="text-center">
                <v-row>
                  <v-col>
                    <h4 class="float-left">WiFi Status: {{WiFi}}</h4>
                  </v-col>
                </v-row>
                <v-row dense>
                <v-col>
                  <h2> Status </h2>
                  <br>
                  <v-chip v-if="status=='naik'" color="success darken-2" large> NAIK </v-chip>
                  <v-chip v-else-if="status=='turun'" color="success darken-2" large> TURUN </v-chip>
                  <v-chip v-else color="error darken-1" large> OFF </v-chip>
                  <br>
                  <br>
                  <v-row>
                    <v-col>
                      <v-data-iterator
                        :items="openings"
                        :items-per-page=10
                        hide-default-footer
                      >
                        <!-- <template v-slot:header>
                          <v-toolbar
                            class="mb-2"
                            color="primary darken-3"
                            dark
                            flat
                          >
                            <v-toolbar-title>Input</v-toolbar-title>
                          </v-toolbar>
                        </template> -->

                        <template v-slot:default="{items}">
                          <v-row 
                            v-for="item in items"
                            :key="item.percentage">
                              <v-col
                                cols="2"
                              >
                                <v-btn 
                                  color="primary"
                                  fab
                                  @click="tableGate(item.percentage,item.time)"
                                >

                                </v-btn>
                              </v-col>
                              <v-col
                                cols="5"
                                v-if="item.percentage!='0'"
                              >
                                <v-text-field 
                                  v-model=item.percentage
                                  label="Percentage"
                                >
                                <template v-slot:append-outer>
                                  %
                                </template>
                                </v-text-field>
                              </v-col>
                              <v-col
                                cols="5"
                                v-else>
                                <v-subheader class="ml-n4">Tutup Maksimal</v-subheader>
                              </v-col>
                              
                              <v-col
                                cols="5"
                                v-if="item.percentage!='0'"
                              >
                                <v-text-field 
                                  v-model=item.time
                                  label="Durasi"
                                >
                                <template v-slot:append-outer>
                                  Detik
                                </template>
                                </v-text-field>
                              </v-col>
                          </v-row>
                        </template>

                      </v-data-iterator>

                      <v-btn
                        class="float-right success"
                        rounded
                        @click="updateTable()"
                      >
                        Save
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                  <v-row>
                    <v-col>
                        <h1>{{opening}} %</h1>
                        <v-slider
                          v-model="opening"
                          readonly
                          step="1"
                          thumb-label
                          ticks
                        >
                        <template v-slot:prepend>
                          <v-icon
                            color="primary"
                            @click="decrement"
                          >
                            mdi-minus
                          </v-icon>
                        </template>

                        <template v-slot:append>
                          <v-icon
                            color="primary"
                            @click="increment"
                          >
                            mdi-plus
                          </v-icon>
                        </template>
                        </v-slider>

                        <v-btn
                          class="float-right success"
                          rounded
                          @click="openGate()"
                        >
                          Save
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4">
                        <v-subheader class="mt-8">Waktu per 1%</v-subheader>
                      </v-col>
                      <v-col cols="8">
                        <v-text-field
                          v-model="timeStep"
                          :rules="number"
                          required
                        >
                          <template v-slot:append>
                            <v-subheader>Detik</v-subheader>
                          </template>
                        </v-text-field>
                        <v-btn
                          class="float-right success"
                          rounded
                          @click="updateStep()"
                        >
                          Save
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                  </v-col>
                </v-row>
                <!-- <v-row>
                  <v-col>
                    <h2 style="color:#1f245b"> History</h2>
                    <v-data-table
                      :headers="headers"
                      :items="historyOpening"
                      :items-per-page="25"
                      :calculate-widths="true"
                      :mobile-breakpoint="500"
                      :loading="tableLoad"
                      class="elevation-1"
                      item-key="timestamp"
                      hide-default-footer
                      disable-pagination
                      disable-sort
                    >
                    <template v-slot:footer>
                      <v-divider class="my-3"></v-divider>
                      <v-row>
                        <v-col> 
                          <v-btn icon class="float-right mx-2" color="#757575" @click="page++;getData(page,itemsPerPage)">
                            <v-icon>mdi-arrow-right</v-icon>
                          </v-btn>
                          <body-1 class="float-right mt-2 mx-2">
                            {{page}}
                          </body-1>
                          <span v-if="page==1">
                            <v-btn disabled icon class="float-right mx-2" color="#757575" @click="page--;getData(page,itemsPerPage)">
                              <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                          </span>
                          <span v-else>
                            <v-btn icon class="float-right mx-2" color="#757575" @click="page--;getData(page,itemsPerPage)">
                              <v-icon>mdi-arrow-left</v-icon>
                            </v-btn>
                          </span>
                          <v-select
                            flat
                            single-line
                            dense
                            :items="[10,30,50]"
                            :value="10"
                            class="float-right mx-2"
                            v-model="itemsPerPage"
                            @change="getData(page,itemsPerPage)"
                            outlined
                          ></v-select>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-slot:[`item.timestamp`]="{ item }">
                      {{updateTime(item.timestamp)}}
                    </template>
                    <template v-slot:[`item.opening`]="{ item }">
                      {{item.opening}} %
                    </template>
                    </v-data-table>
                  </v-col>
                </v-row> -->
              </v-card-text>
        </v-card>
      </v-col>
    </v-row>    
  </v-container>
</template>

<script>
  import { db } from '@/firebase/db.js'
  import moment from 'moment'
  import axios from "axios"
  // import firebase from "firebase/compat/app"
  // import 'firebase/compat/auth';

  export default {
    name: 'AddDevice',

    data: () => ({
      openings:[],
      timeStep:null,
      status:'off',
      opening:null,
      historyOpening:[],
      valid: true,
      number: [
        v => !!v || 'This Field is required',
        v => /^-?[0-9]*\.?[0-9]*$/.test(v) || 'Only number is allowed'
      ],
      IDRules: [
        v => !!v || 'ID is Required',
        v => (v && v.length >=8) || 'ID must be at least 8 characters'
      ],
      nameRules: [
        v => !!v || 'This Field is required'
      ],
      tableLoad:true,
      headers: [
        {
          text: 'Waktu',
          align: 'start',
          value: 'timestamp',
        },
        { text: 'Bukaan', value: 'opening' },
      ],
      offset:null,
      WiFi:'offline, offline',
    }),
    async mounted() {
      const date=new Date();
      this.offset=date.getTimezoneOffset()/(-60)
      setInterval(await this.getWiFiStatus(), 30000);
      await db.collection('Gate').doc('tuya').onSnapshot((doc)=> {
        this.opening=doc.data().opening
        this.timeStep=doc.data().step
        this.status=doc.data().status
        this.openings=[]
        doc.data().openings.forEach((data)=> {
          this.openings.push(data)
        })
      })
      
      
      // await db.collection('Gate').doc('tuya').collection('History').orderBy('timestamp','desc').onSnapshot((docs)=> {
      //   this.historyOpening=[]
      //   docs.forEach((doc)=> {
      //     this.historyOpening.push(doc.data())
      //   })
      //   console.log(this.historyOpening)
      //   this.tableLoad=false
      // })
    },
    methods: {
      async getWiFiStatus() {
        let loader=this.$loading.show()
        await axios.get('https://mcb-qjvqaqprba-uc.a.run.app/status').then(async (res) => {
          loader.hide()
          this.WiFi=`${res.data.device0?'online':'offline'}, ${res.data.device1?'online':'offline'}`
          console.log(res)
        })
        .catch(function (error) {
          console.log(error);
          loader.hide();
        });
      },
      updateTime (time) {
        return moment.unix(time).utcOffset(this.offset).format("HH:mm, DD MMM YYYY")
      },
      increment () {
        if (this.opening<100) {
          this.opening+=1;
        }
      },

      decrement () {
        if (this.opening>0) {
          this.opening-=1
        }
      },
      async updateStep() {
        let loader = this.$loading.show()
        await db.collection('Gate').doc('tuya').update({
          step: this.timeStep
        }).then(()=> {
          loader.hide()
        }).catch(()=> {
          loader.hide()
        })
      },
      async updateTable() {
        let loader = this.$loading.show()
        await db.collection('Gate').doc('tuya').update({
          openings:this.openings
        }).then (()=> {
          loader.hide()
        }).catch (() => {
          loader.hide()
        })
      },
      async tableGate(opening,openingTime) {
        if (opening =='0') {
          let loader=this.$loading.show()
          await axios.get('https://mcb-qjvqaqprba-uc.a.run.app/close').then(async () => {
            loader.hide()
            var gateRef = db.collection('Gate').doc('tuya')
            await gateRef.update({
              opening:opening
            }).then(async() => {
              await gateRef.collection('History').add({
                opening:opening,
                timestamp:new Date()/1000
              }).then(() => {
              }).catch(() => {
                loader.hide()
              })
            }).catch(() => {
              loader.hide()
            })
          })
          .catch(function (error) {
            console.log(error);
            loader.hide();
          });
        } else {
          await this.updateGate(openingTime,opening);
        }
      },
      async openGate() {
        await this.updateGate(this.opening*this.timeStep,this.opening)
      },
      async updateGate(openingTime,opening) { 
        let loader = this.$loading.show()
        console.log(openingTime*1000)
        await axios.post('https://mcb-qjvqaqprba-uc.a.run.app/naik', {
          time: openingTime*1000
        }).then(async () => {
          loader.hide()
          var gateRef = db.collection('Gate').doc('tuya')
          await gateRef.update({
            opening:opening
          }).then(async() => {
            await gateRef.collection('History').add({
              opening:opening,
              timestamp:new Date()/1000
            }).then(() => {
            }).catch(() => {
              loader.hide()
            })
          }).catch(() => {
            loader.hide()
          })
        })
        .catch(function (error) {
          console.log(error);
          loader.hide();
        });
      } 
    },
  }
</script>
